import { render, staticRenderFns } from "./Amostras.vue?vue&type=template&id=e2f28c30&scoped=true&"
import script from "./Amostras.vue?vue&type=script&lang=js&"
export * from "./Amostras.vue?vue&type=script&lang=js&"
import style0 from "./Amostras.vue?vue&type=style&index=0&id=e2f28c30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f28c30",
  null
  
)

export default component.exports